import ExportarDados from '../pages/ExportarDados/index'

export default [
  {
    path: '/exportar-dados',
    component: () => import('@/pages/ExportarDados/Template.vue'),
    children: [
      {
        path: '/exportar-dados',
        component: ExportarDados,
      },
    ],
  },
]
